import { render } from "./AuthenticationLayout.vue?vue&type=template&id=4d3f4c3e&scoped=true"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=ts"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=ts"

import "./AuthenticationLayout.vue?vue&type=style&index=0&id=4d3f4c3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d3f4c3e"

export default script